export const updateDomainInfo = (context) => (id) => ({
    type: "CONSOLE.DOMAINS.UPDATE_INFO",
    payload: { id },
    context,
});

export const renewCertificates = (context) => (id) => ({
    type: "CONSOLE.DOMAINS.RENEW_CERTIFICATES",
    payload: { id },
    context,
});
